import {useEffect, useState} from "react";
import {httpsCallable} from "firebase/functions";
import {Functions} from "../../../firebase/firebase";
import {CampaignProps} from "../../../global/schemas/data/campaigns/campaign";

type OkRes = { status: "OK"; response: CampaignProps[]; domain?: string };
type ErrRes = { status: "Error"; message?: string; code?: number };
type Res = OkRes | ErrRes;

export async function callGetCampaigns(
  managerID: string,
): Promise<CampaignProps[]> {
  const fn = httpsCallable(Functions, "call-admin-campaign-getCampaigns");

  const data = {managerID};

  const res = (await fn(data)).data as Res;

  if (res.status === "OK") {
    return res.response;
  }

  throw new Error(res.message || `Feil (${"ukjent"})`);
}

export function useGetCampaign(managerID: string | undefined) {
  const [campaigns, setCampaigns] = useState<CampaignProps[] | undefined>();

  useEffect(() => {
    if (!managerID) return;

    let cancelled = false;

    callGetCampaigns(managerID)
      .then((list) => {
        if (!cancelled) {
          setCampaigns(list);
        }
      })
      .catch((error) => {
        if (!cancelled) {
          console.error("getCampaigns callable error", error);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [managerID]);
  return campaigns;
}
